import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/styles';
import useAuth from '../../authentication/useAuth';
import { CanSendFeedback } from '../../utils/forms';
import AccountMenuPanel from './components/AccountMenuPanel';
import AccountPickerTrigger from './components/AccountPickerTrigger';

function AccountPicker() {
	const theme = useTheme();
	const { t } = useTranslation('account', 'common');
	const [anchorEl, setAnchorEl] = useState(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
	const { signoutRedirect, getCurrentUser, isImpersonating, endImpersonation } =
		useAuth();
	const currentUser = getCurrentUser();
	const canSendFeedback = CanSendFeedback();
	const isMenuOpen = Boolean(anchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	const navigate = useNavigate();

	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		handleMobileMenuClose();
	};

	const handleProfileMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleNavigateMyAccount = () => {
		handleMenuClose();
		setTimeout(() => {
			navigate('/account/me');
		}, 1);
	};

	const handleNavigateContactUs = () => {
		handleMenuClose();
		setTimeout(() => {
			navigate('/contact/us');
		}, 1);
	};

	const handleNavigateImpersonateCustomers = () => {
		handleMenuClose();
		setTimeout(() => {
			navigate('/account/impersonate');
		}, 1);
	};

	const endUserImPersonation = () => {
		endImpersonation();
		handleMenuClose();
		setTimeout(() => {
			navigate('/account/impersonate');
		}, 1);
	};

	const handleLogout = async () => {
		try {
			handleMenuClose();
			signoutRedirect();
		} catch (err) {
			console.error(err);
		}
	};

	const desktopMenuView = (
		<AccountMenuPanel
			isMobile={false}
			anchorEl={anchorEl}
			isOpen={isMenuOpen}
			theme={theme}
			t={t}
			currentUser={currentUser}
			canSendFeedback={canSendFeedback}
			isImpersonating={isImpersonating}
			onClose={handleMenuClose}
			onNavigateMyAccount={handleNavigateMyAccount}
			onNavigateContactUs={handleNavigateContactUs}
			onNavigateImpersonateCustomers={handleNavigateImpersonateCustomers}
			onEndImpersonation={endUserImPersonation}
			onLogout={handleLogout}
		/>
	);

	const mobileMenuView = (
		<AccountMenuPanel
			isMobile
			anchorEl={mobileMoreAnchorEl}
			isOpen={isMobileMenuOpen}
			theme={theme}
			t={t}
			currentUser={currentUser}
			canSendFeedback={canSendFeedback}
			isImpersonating={isImpersonating}
			onClose={handleMobileMenuClose}
			onNavigateMyAccount={handleNavigateMyAccount}
			onNavigateContactUs={handleNavigateContactUs}
			onNavigateImpersonateCustomers={handleNavigateImpersonateCustomers}
			onEndImpersonation={endUserImPersonation}
			onLogout={handleLogout}
		/>
	);

	return (
		<div>
			<AccountPickerTrigger
				currentUser={currentUser}
				onOpenMenu={handleProfileMenuOpen}
				theme={theme}
			/>
			{mobileMenuView}
			{desktopMenuView}
		</div>
	);
}

export default AccountPicker;
